import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import { DEFAULT_SOURCE_CURRENCY } from 'utils';
import { getMbArchiveTabPath } from 'utils/mbArchive';

import { Wrapper, Tab } from './styles';

const TAB_CURRENCIES = ['usd', 'eur'];

const MbArchiveTabs = () => {
  const {
    currency = DEFAULT_SOURCE_CURRENCY,
    date,
    dateFrom,
    dateTo,
  } = useParams();

  const activeCurrency = currency.toLowerCase();

  const tabs = useMemo(
    () =>
      TAB_CURRENCIES.map(tabCurrency => ({
        value: tabCurrency,
        to: getMbArchiveTabPath({
          tabCurrency,
          date,
          dateFrom,
          dateTo,
        }),
      })),
    [date, dateFrom, dateTo]
  );

  return (
    <Wrapper>
      {tabs.map(({ value, to }) => (
        <Tab
          key={value}
          to={to}
          $active={activeCurrency === value}
          aria-current={activeCurrency === value ? 'page' : undefined}
        >
          <FormattedMessage id={`mbArchivePage.tab.${value}`} />
        </Tab>
      ))}
    </Wrapper>
  );
};

export default MbArchiveTabs;
